/* eslint-disable */
// @ts-nocheck
import * as React from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';
import { hasAccess } from '../../support/utils/accessControlHelpers';
import type { AccessControlReducer } from '../../../main/types/accessControlTypes';
type Props = {
  accessControl: AccessControlReducer;
  accessResources: Array<string>;
  children: React.ReactElement<any>;
  permission: number;

  /**
   * name of the prop that will be passed to children
   * It will be set to true if access denied
   */
  accessDeniedPropName: string;
};

/**
 * Wrapper component which checks if the user has required access
 * and passes in a prop to the children
 */
export class AccessControlWrapper extends React.Component<Props> {
  static defaultProps = {
    accessDeniedPropName: 'disabled',
  };

  render() {
    if (hasAccess(this.props.accessResources, this.props.permission, this.props.accessControl.data)) {
      return React.Children.only(this.props.children);
    }

    return React.cloneElement(this.props.children, {
      [this.props.accessDeniedPropName]: true,
    });
  }
}
export default connect(R.pick(['accessControl']))(AccessControlWrapper);
